import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { HEADER } from '../../constants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { taskActions, bottomnavActions, headerActions, referralActions } from '../../actions';
import ContentLoader from 'components/common/loaders/ContentLoader';
import TaskList from './TaskList';

const headerSettings = {
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Tasks',
  hasBackButton: false,
  hasNotificationIcon: true
};

class Tasks extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    setHeader: PropTypes.func.isRequired,
    setActiveOpportunity: PropTypes.func.isRequired,
    changeActiveItem: PropTypes.func.isRequired,
    fetchReferrals: PropTypes.func.isRequired,
    referrals: PropTypes.array,
    tasks: PropTypes.array
  }

  componentDidMount = async () => {
    this.props.setHeader(headerSettings);
    this.props.changeActiveItem('Tasks');
    await this.props.fetch();
    this.props.fetchReferrals();
  }

  render () {
    const { tasks, setActiveOpportunity, referrals } = this.props;
    return (
      <React.Fragment>
        <section className='page-content tasks-page'>
          {
            !tasks ? <ContentLoader isLoading />
              : <TaskList tasks={tasks} setActiveOpportunity={setActiveOpportunity} referrals={referrals} />
          }
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { tasks, referrals } = state;
  return {
    tasks: _.get(tasks, 'tasks', null),
    referrals: _.get(referrals, 'allReferrals', []),
    opportunities: _.get(referrals, 'opportunities', [])
  };
};

const mapDispatchProps = (dispatch) => ({
  fetch: bindActionCreators(taskActions.fetchTasks, dispatch),
  fetchReferrals: bindActionCreators(referralActions.fetch, dispatch),
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  changeActiveItem: bindActionCreators(bottomnavActions.changeActiveItem, dispatch),
  setActiveOpportunity: bindActionCreators(referralActions.setActiveOpportunity, dispatch)
});

export default connect(mapStateToProps, mapDispatchProps)(withRouter(Tasks));
